module.exports = "<script type=\"text/javascript\">\n[... see above ...]\ndivvit.init(\"YOUR_FRONTEND_ID\");\ndivvit.pageview();\ndivvit.customer({\n   // all these fields will be used to identify this logged-in user\n   // you can specify as many fields as you need to uniquely identify a user\n   // typically, the email address or customer ID should be enough\n   email: \"david@smith.com\",\n   customerId: \"123456\"\n   // ...\n});\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/customer.html
// module id = 2150
// module chunks = 0